import request from '@/utils/request'
import qs from 'qs'

//甄选藏品
export function collectionGetUsedAll(data) {
    return request({
        url: '/xchk/collection/getUsedAll',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/selectionOfCollections.js